import { useDataStore } from "@/stores/data";

function isIp(host) {
  return /^\d{1,3}(\.\d{1,3}){3}$/.test(host || "");
}

function toInt(v, def = undefined) {
  const n = Number(v);
  return Number.isFinite(n) ? String(n) : def;
}

function buildVideoUrlFromDevice(device) {
  const dd = device?.dynamicData || {};
  const secure = !!dd.dynamic_secureChannel;

  // prefer device-provided host, else current host
  let host = dd.dynamic_dns || window.location.hostname;

  // If secure and host is an IP, prefer current page hostname to avoid CN mismatch
  if (secure && isIp(host)) {
    host = window.location.hostname;
  }

  // Port rules: use device port if present, else inherit current port (keeps :12443 etc.)
  let port = dd.dynamic_serverPort
    ? toInt(dd.dynamic_serverPort, "")
    : window.location.port;

  // If standard ports, drop explicit port
  if ((secure && port === "443") || (!secure && port === "80")) port = "";

  const proto = secure ? "https" : "http";
  const path = `/video/${encodeURIComponent(device?.serialNumber || "")}.m3u8`;

  const url = new URL(`${proto}://${host}${path}`);
  if (port) url.port = port;

  return url.toString();
}

// pega URL do valor da variável que aponta pro stream
function getUrlFromVariable(videoConfig) {
  const dataStore = useDataStore();

  // ajuste aqui se o id REAL estiver em videoConfig.dynamicData.id ou similar
  const dynId = videoConfig.id;
  if (!dynId) return "";

  const variableValue = dataStore.getById(dynId);
  // console.log("getUrlFromVariable:", dynId, variableValue);
  if (!variableValue) return "";

  if (typeof variableValue === "string") return variableValue.trim();
  if (typeof variableValue.value === "string")
    return variableValue.value.trim();
  if (typeof variableValue.lastValue === "string")
    return variableValue.lastValue.trim();

  return "";
}

function transformForRealTime(urlStr, isRealTime, fromBuilder) {
  if (!isRealTime || !urlStr) return urlStr;

  try {
    const u = new URL(urlStr, window.location.origin);

    // if this URL came from the builder, we know it has /video/... -> strip it
    if (fromBuilder && u.pathname.startsWith("/video")) {
      u.pathname = u.pathname.replace(/^\/video/, "");
    }

    // ensure no trailing slash before adding whep
    u.pathname = u.pathname.replace(/\/$/, "") + "/whep";

    return u.toString();
  } catch (e) {
    console.warn(
      "Invalid URL for realTime transform, returning as-is:",
      urlStr,
      e
    );
    return urlStr;
  }
}

/**
 * Builds the final source URL for a videoConfig + device.
 * - Always needs the device (to know realTime + dynamicData).
 * - Tries URL from variable first, falls back to device-based URL.
 * - Applies WHEP rules when realTime.
 */
export function buildSourceForVideoConfig(videoConfig, device) {
  if (!device) return { url: "", isRealTime: false };

  const isRealTime =  videoConfig.realTime;

  let urlStr = getUrlFromVariable(videoConfig);
  const fromBuilder = !urlStr;

  if (!urlStr) {
    urlStr = buildVideoUrlFromDevice(device);
  }

  urlStr = transformForRealTime(urlStr, isRealTime, fromBuilder);

  // you already do this in the component – keep it here so it’s consistent

  return { url: urlStr, isRealTime };
}
